module.exports = __webpack_public_path__ + "media/src/website/images/locations/burghausen/burghausen_02-aa60983213b4a2b9aaefff5083ec4ea5.jpg";